import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'duration',
    standalone: true
})
export class DurationPipe implements PipeTransform {
    /**
     * Transform duration in seconds to human-readable format
     * @param value - duration in seconds
     * @returns formatted string like "2m 15s" or "1h 30m 45s"
     */
    transform(value: number | null | undefined): string {
        if (value === null || value === undefined || value < 0) {
            return '—';
        }

        const seconds = Math.floor(value);

        if (seconds < 60) {
            return `${seconds}s`;
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const parts: string[] = [];

        if (hours > 0) {
            parts.push(`${hours}h`);
        }

        if (minutes > 0) {
            parts.push(`${minutes}m`);
        }

        if (remainingSeconds > 0 || parts.length === 0) {
            parts.push(`${remainingSeconds}s`);
        }

        return parts.join(' ');
    }
}
